define([
	"dojo/_base/declare",
	"./_SizesRenderer"
], function(declare,_SizesRenderer) {

	return declare(_SizesRenderer, {
		/**
		 * Return size range node where sizes came from
		 * @param {Context} ctx
		 * @return {Node | null}
		 */
		getSizeRange: function(ctx) {
			const {cache} = ctx;
			const avatar = ctx.getNode();
			if (!avatar) {
				return null;
			}
			return cache.get(avatar.SizeRange);
		}
	});
});
